import {
  defaultNumberOfIconEventTypes,
  eventTypeCustomizations,
} from "../../../../../Constants/eventTypeCustomization";
import { iconEventTypes, sortEventTypes } from "Helpers/EventTypes";
import { EventType, EventTypeWithIcon } from "../../../Models/event.model";
import { RxCoverageApplicationState } from "../RxCoverageApplication";
import { getKnownVenue } from "./venue.selector";
import eventSelectList from "Helpers/EventSelectList";

const getCustomizedEvents = (state: RxCoverageApplicationState) => {
  const updated = [...state.eventTypes.data];
  eventTypeCustomizations.forEach((customization) => {
    const index = updated.findIndex(
      (subject) => subject.identifier === customization.identifier,
    );
    updated[index] = { ...updated[index], ...customization };
  });
  return updated;
};

export const getIconEventTypes = (state: RxCoverageApplicationState) => {
  const knownVenue = getKnownVenue(state);
  const venueEventTypes = knownVenue?.eventTypes || [];
  return iconEventTypes(
    getCustomizedEvents(state),
    venueEventTypes,
    knownVenue?.eventTileShowCount || defaultNumberOfIconEventTypes,
  ) as EventTypeWithIcon[];
};

export const getListEventTypesOptions = (state: RxCoverageApplicationState) => {
  const knownVenue = getKnownVenue(state);
  const venueEventTypes = knownVenue?.eventTypes || [];

  let list = sortEventTypes(
    getCustomizedEvents(state),
    venueEventTypes,
  ) as EventType[];

  const { eventCategoryFilter } = state.applicationForm.root.value;

  if (eventCategoryFilter) {
    list = list.filter(({ categories }) =>
      categories.includes(eventCategoryFilter),
    );
  }

  return eventSelectList(list).map((eventType: EventType) => ({
    value: eventType,
    label: eventType.name,
  }));
};

export const getEventCategoryOptions = (state: RxCoverageApplicationState) => {
  const allCategoriesWithDuplicates = state.eventTypes.data
    .reduce((acc, { categories }) => {
      return acc.concat(categories);
    }, [])
    .sort();

  // Remove duplicate categories and return options
  return [...new Set(allCategoriesWithDuplicates)].map((category) => ({
    label: category,
    value: category,
  }));
};

export const getSelectedEvent = (state: RxCoverageApplicationState) =>
  state.applicationForm.eventType.value as EventType;

export const getEventType = (
  state: RxCoverageApplicationState,
  identifier: string,
) =>
  state.eventTypes.data?.find(
    (eventType) => eventType.identifier === identifier,
  );

export const getSelectedEventIcon = (state: RxCoverageApplicationState) => {
  const selectedEvent = getSelectedEvent(state);

  const customIcon = eventTypeCustomizations.find(
    ({ identifier }) => identifier === selectedEvent.identifier,
  )?.selectionIcon;

  const icon =
    selectedEvent.icon === "General" ? undefined : selectedEvent.icon;

  return customIcon || icon;
};
